"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBlockForIndex_1 = __importDefault(require("../query/getBlockForIndex"));
const id_1 = __importDefault(require("../EditorState/id"));
const constants_1 = require("../constants");
function splitBlock(editorState, start, end) {
    const { block: currentBlock } = getBlockForIndex_1.default(editorState.list.value, start);
    const blockEnd = { type: 'block-end' };
    const blockStart = Object.assign(Object.assign({ styles: [] }, currentBlock), { type: 'block-start', blockKey: id_1.default() });
    const newEditorState = editorState.change({
        isBoundary: true,
        type: constants_1.COMMAND.SPLIT_BLOCK,
        start,
        end,
        value: [
            blockEnd,
            blockStart
        ]
    }).change({
        type: constants_1.COMMAND.SPLIT_BLOCK,
        start: start + 2,
        end: start + 2,
        value: [],
    });
    return newEditorState;
}
exports.default = splitBlock;
//# sourceMappingURL=splitBlock.js.map